// extracted by mini-css-extract-plugin
module.exports = {"card":"jYX4udRekgBsYpJViYCh","description":"ML7sp1S5P1719CDinnob","delay":"Yzf9qAKq6JF576md2sEd","delayWrapper":"G_HXUpXgKIsXHZWsqrdf"};